import {
  BUSINESS_UNIT,
  COMPONENT,
} from '@zola-helpers/client/dist/es/tracking/onboard/onboardTrackingConstants';
import { CARD_TYPES } from 'cards/components/CardListing/types';
import { trackEvent } from '@zola-helpers/client/dist/es/tracking/trackingHelper';

interface FavoritingEventPayload {
  type: CARD_TYPES;
  uuid: string;
}
interface FavoritingEvent extends FavoritingEventPayload {
  eventName: string;
}

/* when a user favorites a photo, wedding, or storefront */
function trackFavoritingEvent({ eventName, type, uuid }: FavoritingEvent): void {
  const payload = {
    business_unit: BUSINESS_UNIT.INVITATIONS,
    component: COMPONENT.FAVORITE,
    uuid,
    object_favorited: type,
  };
  trackEvent(eventName, payload);
}

export function trackObjectFavorited(payload: FavoritingEventPayload): void {
  trackFavoritingEvent({ eventName: 'Object Favorited', ...payload });
}

export function trackObjectUnfavorited(payload: FavoritingEventPayload): void {
  trackFavoritingEvent({ eventName: 'Object Unfavorited', ...payload });
}
